import React, { useState } from "react";

const EditAbout = () => {
  const [sectionTitle, setSectionTitle] = useState("");
  const [paragraphs, setParagraphs] = useState([""]);

  const handleSectionTitleChange = (e) => {
    setSectionTitle(e.target.value);
  };

  const handleParagraphChange = (index, e) => {
    const newParagraphs = [...paragraphs];
    newParagraphs[index] = e.target.value;
    setParagraphs(newParagraphs);
  };

  const handleAddParagraph = () => {
    setParagraphs([...paragraphs, ""]);
  };

  const handleRemoveParagraph = (index) => {
    setParagraphs(paragraphs.filter((_, i) => i !== index));
  };

  const handleSaveChanges = () => {
    const data = { sectionTitle, paragraphs };
    console.log("Saving changes:", data);
    // Replace with API call or other save logic
  };

  return (
    <div className="edit-about">
      <h2>Edit About Section</h2>

      {/* Section Title Input */}
      <div className="form-group">
        <label htmlFor="sectionTitle">Section Title</label>
        <input
          type="text"
          id="sectionTitle"
          value={sectionTitle}
          onChange={handleSectionTitleChange}
          placeholder="Enter section title"
        />
      </div>

      {/* Paragraphs Input */}
      {paragraphs.map((paragraph, index) => (
        <div key={index} className="form-group paragraph-group">
          <label htmlFor={`paragraph-${index}`}>Paragraph {index + 1}</label>
          <textarea
            id={`paragraph-${index}`}
            value={paragraph}
            onChange={(e) => handleParagraphChange(index, e)}
            placeholder="Enter paragraph details"
          ></textarea>
          <button
            type="button"
            onClick={() => handleRemoveParagraph(index)}
            className="remove-paragraph-btn"
          >
            Remove
          </button>
        </div>
      ))}

      {/* Add More Paragraph Button */}
      <button type="button" onClick={handleAddParagraph} className="add-paragraph-btn">
        Add More Paragraph
      </button>

      {/* Save Changes Button */}
      <button type="button" onClick={handleSaveChanges} className="save-btn">
        Save Changes
      </button>
    </div>
  );
};

export default EditAbout;
